"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const flatten_1 = __importDefault(require("lodash/flatten"));
const timeago_js_1 = require("timeago.js");
const UserContext_1 = require("context/UserContext");
const useIntersectionObserver_1 = __importDefault(require("hooks/useIntersectionObserver"));
const HelperUtils_1 = require("utils/HelperUtils");
const Avatar_1 = __importDefault(require("components/design-system/Avatar"));
const Tabs_1 = __importDefault(require("components/design-system/tabs/Tabs"));
const BannerBox_1 = __importDefault(require("components/shared/BannerBox"));
const ListEmptyState_1 = __importDefault(require("components/shared/ListEmptyState"));
const LoadingComponent_1 = __importDefault(require("components/shared/LoadingComponent"));
const SVGIcon_1 = __importDefault(require("components/shared/SVGIcon"));
const useFormalReview_1 = require("src/api/useFormalReview");
const ActorList = ({ actors, isPeerWording = false }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null, actors?.map((actor, index) => (react_1.default.createElement("span", { className: `first:ml-[0px] ml-[4px] ${isPeerWording
            ? 'typography-h400 text-n-900'
            : 'typography-h100 text-n-800'}`, key: index },
        actor,
        actors?.length > 2 && index < actors?.length - 1 && react_1.default.createElement(react_1.default.Fragment, null, ","),
        actors?.length > 1 && actors?.length - 2 == index && (react_1.default.createElement(react_1.default.Fragment, null,
            " ",
            (0, HelperUtils_1.getObjectiveLocale)('and'))))))));
};
const HistoryItem = ({ dataHistory }) => {
    const { organization } = (0, UserContext_1.useUser)();
    const { user, event, actors, createdAt } = dataHistory;
    const isPeerWording = event?.includes('review_each_other');
    const isAddingPeer = event?.includes('adding');
    return (react_1.default.createElement("div", { className: "px-[8px] py-[12px] mb-[16px] flex bg-n-200 rounded " },
        react_1.default.createElement("div", { className: "flex relative mr-[16px]" },
            react_1.default.createElement(Avatar_1.default, { name: isPeerWording ? organization?.name : user?.name, src: isPeerWording ? organization?.logoUrl : user?.profilePicture, size: 40 }),
            react_1.default.createElement(SVGIcon_1.default, { iconName: "icon-pencil", size: 8, customClass: "w-[16px] h-[16px] bg-base-100 rounded-full border border-solid border-n-000 flex items-center justify-center absolute bottom-[0px] right-[-4px]", fillColor: "var(--base-600)" })),
        react_1.default.createElement("div", { className: "flex flex-col" },
            react_1.default.createElement("p", { className: "mb-[8px]" }, isPeerWording ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(ActorList, { actors: actors, isPeerWording: true }),
                react_1.default.createElement("span", { className: `typography-h100 text-n-800 ${isPeerWording ? 'ml-[4px]' : ''}` }, (0, HelperUtils_1.getObjectiveLocale)(`automatically ${isAddingPeer ? 'added' : 'deleted'} by review each other`)))) : (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("span", { className: "typography-h400 text-n-900 mr-[4px]" }, user?.name),
                react_1.default.createElement("span", { className: "typography-h100 text-n-800" }, (0, HelperUtils_1.getObjectiveLocale)(isAddingPeer ? 'add' : 'remove')),
                react_1.default.createElement(ActorList, { actors: actors })))),
            react_1.default.createElement("p", { className: "typography-h100 text-n-600" }, (0, timeago_js_1.format)(createdAt)))));
};
const ModalPeerHistoryTab = ({ cycleId, targetId }) => {
    const { data: histories, isFetching, isFetchingNextPage, hasNextPage, fetchNextPage } = (0, useFormalReview_1.useGetHistory)(cycleId, targetId, {
        staleTime: 5000, // 5 seconds
        getNextPageParam: (lastPage) => {
            if (lastPage?.data?.length === 10) {
                return lastPage.pagination?.next?.olderThan;
            }
        }
    });
    const newHistories = (0, flatten_1.default)(histories?.pages?.map((page) => {
        return page?.data?.map((d) => {
            return d;
        });
    }));
    const intersectTarget = (0, react_1.createRef)();
    (0, useIntersectionObserver_1.default)({
        target: intersectTarget,
        onIntersect: (entry) => entry.isIntersecting &&
            !isFetchingNextPage &&
            hasNextPage &&
            fetchNextPage(),
        threshold: 1
    });
    return (react_1.default.createElement(Tabs_1.default.Content, { id: "history-tab" },
        newHistories?.length > 0 && (react_1.default.createElement("div", { className: "mt-[16px]" },
            react_1.default.createElement(BannerBox_1.default, { customClass: "mx-[16px]", paddingClass: "px-[16px] py-[8px]", text: (0, HelperUtils_1.getObjectiveLocale)('The history only shows reviewee logs.'), type: "info", dataCy: "bannerbox-info-history" }))),
        react_1.default.createElement("div", { className: `mx-[16px] ${newHistories?.length > 0 ? '' : 'h-[180px] py-[16px]'}` },
            isFetching && !isFetchingNextPage ? (react_1.default.createElement(LoadingComponent_1.default, null)) : newHistories?.length > 0 ? (newHistories?.map((history, index) => (react_1.default.createElement(HistoryItem, { dataHistory: history, key: index })))) : (react_1.default.createElement(ListEmptyState_1.default, { emptyIcon: "icon-no-activities", size: "small", title: (0, HelperUtils_1.getObjectiveLocale)('No history yet'), subtitle: (0, HelperUtils_1.getObjectiveLocale)("Once any activities in peer selection, you'll see them here"), fullHeight: true })),
            react_1.default.createElement("div", { className: "h-[1px]", ref: intersectTarget }, "\u00A0"),
            isFetchingNextPage && react_1.default.createElement(LoadingComponent_1.default, null))));
};
exports.default = ModalPeerHistoryTab;
